import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  Box,
  CircularProgress,
  IconButton,
  Typography,
  alpha,
  Divider,
  Stack,
} from '@mui/material';
import { Close as CloseIcon, SecurityOutlined } from '@mui/icons-material';

import { getPrivileges } from '../../../../helpers/api';
import { openNotification } from '../../../../helpers/notification';
import EditRoleForm from './EditRoleForm';
import ModalHeader from './ModalHeader';
import './EditRole.css';

const EditRole = ({ open, close, roleName, desc, privileges, roleId, category }) => {
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      refreshPrivileges();
    }
  }, [open]);

  const refreshPrivileges = () => {
    setLoading(true);
    getPrivileges()
      .then((res) => {
        setPermissions(res.result.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        openNotification({
          type: 'error',
          title: 'Error getting permissions',
          message: error.message,
        });
      });
  };

  return (
    <Dialog
      open={open}
      onClose={close}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          borderRadius: '20px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
          overflow: 'hidden',
        },
      }}
    >
      {/* CUSTOM DIALOG HEADER */}
      <Box
        sx={{
          p: 2.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          bgcolor: '#fff',
        }}
      >
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Box
            sx={{
              p: 1,
              borderRadius: '10px',
              bgcolor: alpha('#1976d2', 0.1),
              color: 'primary.main',
              display: 'flex',
            }}
          >
            <SecurityOutlined fontSize="small" />
          </Box>
          <Box>
            <Typography variant="h6" fontWeight={700} color="text.primary" sx={{ lineHeight: 1.2 }}>
              Update Role Permissions
            </Typography>
            <Typography variant="caption" color="text.secondary" fontWeight={600}>
              Modifying settings for: {roleName}
            </Typography>
          </Box>
        </Stack>

        <IconButton
          onClick={close}
          size="small"
          sx={{
            bgcolor: alpha('#000', 0.05),
            '&:hover': { bgcolor: alpha('#d32f2f', 0.1), color: '#d32f2f' },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <Divider />

      <DialogContent sx={{ p: 0, minHeight: '400px', display: 'flex', flexDirection: 'column' }}>
        {loading ? (
          <Box
            sx={{
              flexGrow: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              py: 10,
            }}
          >
            <CircularProgress size={40} thickness={4} sx={{ mb: 2 }} />
            <Typography variant="body2" color="text.secondary" fontWeight={600}>
              Fetching latest permissions...
            </Typography>
          </Box>
        ) : (
          <Box sx={{ p: 4 }}>
            <EditRoleForm
              permissions={permissions}
              closeEditModal={close}
              name={roleName}
              desc={desc}
              privileges={privileges}
              id={roleId}
              userCategory={category}
            />
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default EditRole;
